import React, { useState, useEffect } from 'react';
import LeaseApiService from '../../services/apiService';
import { FaSave, FaChevronLeft } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import PersonalDetails from './details';
import { getCountryFromCurrency } from '../../../INVENTORY/Layouts/currencyHelpers';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { getCompany, getName } from '../../../Redux/selecters';
import OtherDetails from './otherDetails';
import Features from './feature';
import ImagesList from './images';
import EscrowAccount from './escrow';
import axios from 'axios';

const createEmptyRow = () => ({
  id: Date.now() + Math.random(),
  file: null, // for new file (File object)
  fileName: '',
  remarks: '',
  filePath: '',
  isNew: true, // ✅ identify new file
  fullUrl: '', // ✅ for existing file preview
});
const PropertyMasterUpdate = () => {
  const apiService = new LeaseApiService();
  let navigate = useNavigate();
  const { currencyPrecision } = useCurrency();
  const userName = useSelector(getName);
  const currencyList = JSON.parse(localStorage.getItem('currencylist')) || [];
  const defaultCountry = currencyPrecision?.code ? getCountryFromCurrency(currencyPrecision?.code, currencyList) : 'bh'; // fallback until API loads
  const [activeFY, setActiveFY] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [gridVisibility, setGridVisibility] = useState([true, false, false, false, false]);
  const [loading, setloader] = useState(false);
  const [propertyType, setPropertyType] = useState([]);
  const [deletedFiles, setDeletedFiles] = useState([]);
  const [ownerShip, setOwnerShip] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [countriesList, setCountries] = useState([]);
  const [projectStatus, setProjectStatus] = useState([]);
  const [projectUse, setProjectUse] = useState([]);
  const [community, setCommunity] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [propertyCategory, setPropertyCategory] = useState([]);
  const [attachments, setAttachments] = useState([createEmptyRow()]);
  const location = useLocation();
  const leaseData = location.state;

  const [transectionData, setTransectionData] = useState({
    propertyNo: '',
    propertyName: '',
    plotNo: '',
    plotSize: '',
    remarks: '',
    propertyDescription: '',
    location: '',
    area: '',
    longitude: '',
    latitude: '',
    video: '',
    community: null,
    country: null,
    city: null,
    propertyType: null,
    ownerShip: null,
    projectStatus: null,
    category: null,
    propertyUse: null,
  });

  useEffect(() => {
    fetchDropdownData();
    const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
    const activeFinancialYear = financialYears?.find((fy) => fy.isActive);
    if (activeFinancialYear) {
      setActiveFY({ label: activeFinancialYear.name, value: activeFinancialYear });
    }
  }, []);
  const fetchDropdownData = async () => {
    try {
      const params = new URLSearchParams();
      params.append('dropdownTypes', 'PropertyType,ProjectStatus,Country,Community,Ownership,PropertyStatus,PropertyCategory');
      const res = await apiService.getApiParamater('PROPERTY_MULTIDROP', `?${params.toString()}`);
      setPropertyType(res?.data?.dropdowns?.PropertyType);
      setCommunity(res?.data?.dropdowns?.Community);
      setProjectStatus(res?.data?.dropdowns?.ProjectStatus);
      setOwnerShip(res?.data?.dropdowns?.Ownership);
      setCountries(res?.data?.dropdowns?.Country);
      setPropertyCategory(res?.data?.dropdowns?.PropertyCategory);
      if (leaseData) {
        const unitres = await apiService.getApiParamater('GET_PROPERTY_BY_ID', `/${leaseData?.property_No}`);
        let unitData = unitres?.data?.result?.property;
        const community = res?.data?.dropdowns?.Community?.find((dep) => dep.text === unitData?.community_Name);
        const country = res?.data?.dropdowns?.Country?.find((dep) => dep.text === unitData?.country);
        const propertyType = res?.data?.dropdowns?.PropertyType?.find((dep) => dep.text === unitData?.property_Type);
        const projectStatus = res?.data?.dropdowns?.ProjectStatus?.find((dep) => dep.text === unitData?.project_Status);
        const ownerShip = res?.data?.dropdowns?.Ownership?.find((dep) => dep.text === unitData?.property_Class);
        const category = res?.data?.dropdowns?.PropertyCategory?.find((dep) => dep.text === unitData?.property_Category);
        const cityParams = new URLSearchParams();
        cityParams.append('DropdownFor', 'CitiesByCountry');
        cityParams.append('CascadValue', country?.text);
        const cityres = await apiService.getApiParamater('PROPERTY_CASCAD', `?${cityParams.toString()}`);
        setCityList(cityres?.data?.items || []);
        const city = cityres?.data?.items?.find((dep) => dep.text === unitData?.city);
        setTransectionData({
          propertyNo: unitData?.property_No || '',
          propertyName: unitData?.description || '',
          plotNo: unitData?.plot_No || '',
          plotSize: unitData?.plot_Size || '',
          remarks: unitData?.remarks || '',
          propertyDescription: unitData?.descriptionBI || '',
          location: unitData?.location || '',
          area: unitData?.gross_Area || '',
          longitude: unitData?.longitude || '',
          latitude: unitData?.latitude || '',
          video: unitData?.exp7 || '',
          community: community ? { label: community?.text, value: community } : null,
          country: country ? { label: country?.text, value: country } : null,
          propertyType: propertyType ? { label: propertyType?.text, value: propertyType } : null,
          projectStatus: projectStatus ? { label: projectStatus?.text, value: projectStatus } : null,
          ownerShip: ownerShip ? { label: ownerShip?.text, value: ownerShip } : null,
          city: city ? { label: city?.text, value: city } : null,
          category: category ? { label: category?.text, value: category } : null,
        });
        const fileparams = new URLSearchParams();
        fileparams.append('refNo', leaseData?.property_No);
        fileparams.append('fileCategory', 'Images');
        const imgRes = await apiService.getApiParamater('GET_FILE', `?${fileparams.toString()}`);
        if (imgRes?.data?.result) {
          const apiFiles = imgRes.data.result.map((item) => ({
            id: Date.now() + Math.random(),
            file: null,
            fileName: item.fileName,
            remarks: '',
            filePath: item?.filePath,
            isNew: false, // ✅ OLD FILE
            fullUrl: item.fullUrl, // ✅ for preview
          }));
          setAttachments([...apiFiles, createEmptyRow()]);
        }
      }
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  };
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
    setGridVisibility(newGridVisibility);
  };
  const handleBackClick = () => {
    window.history.back();
  };
  const handleSave = async () => {
    try {
      setloader(true);
      const currentDatetimeUTC = new Date().toISOString();
      const today = new Date();
      let property = {
        property_No: transectionData?.propertyNo || '0',
        description: transectionData?.propertyName || '0',
        descriptionBI: transectionData?.propertyDescription || '0',
        project: '0',
        location: transectionData?.location || '0',
        address1: '0',
        city: transectionData?.city?.label || '0',
        country: transectionData?.country?.label || '0',
        subDistrict: '0',
        district: '0',
        plot_No: transectionData?.plotNo || '0',
        subPlot_No: '0',
        plot_Size: transectionData?.plotSize || '0',
        community_No: transectionData?.community?.value?.value || '0',
        community_Name: transectionData?.community?.label || '0',
        subCommunity_No: '0',
        subCommunity_Name: '0',
        contact_Person: '0',
        contact_No: '0',
        rate_Sqft: '0',
        developer: '0',
        dContactNo: '0',
        dEmail: '0',
        dContactPerson: '0',
        subDeveloper: '0',
        sdContactNo: '0',
        sdEmail: '0',
        sdContactPerson: '0',
        agent: '0',
        subAgent: '0',
        contractor: '0',
        subContractor: '0',
        total_Units: '0',
        total_Parking: '0',
        floors: '0',
        built_Area: '0',
        gross_Area: transectionData?.area || '0',
        property_Type: transectionData?.propertyType?.label || '0',
        property_Category: transectionData?.category?.label || '0',
        property_Class: transectionData?.ownerShip?.label || '0',
        start_Date: '2026-05-04T17:22:52.606Z',
        end_Date: '2026-05-04T17:22:52.606Z',
        project_Cost: '0',
        project_Status: transectionData?.projectStatus?.label || '0',
        facilities: '0',
        remarks: transectionData?.remarks || '0',
        escrow_Bank: '0',
        escrow_BankAcc: '0',
        latitude: transectionData?.latitude || '0',
        longitude: transectionData?.longitude || '0',
        image_Filename: '0',
        ownerNo: '0',
        ownerName: '0',
        ownerContactNo: '0',
        ownerEmail: '0',
        referredBy: '0',
        referredOn: '2026-05-04T17:22:52.606Z',
        exp1: '0',
        exp2: '0',
        exp3: '0',
        exp4: '0',
        exp5: '0',
        exp6: '0',
        cardNumber: '0',
        bondNumber: '0',
        bondType: '0',
        bondDate: '2026-05-04T17:22:52.606Z',
        exp7: transectionData?.video || '0',
        exp8: '0',
        exp9: '0',
        exp10: '0',
        exp11: '0',
        exp12: '0',
        modifiedBy: '0',
        modifiedOn: today,
        createdBy: '0',
        createdOn: today,
      };
      const body = {
        propertyMain: {
          property: property,
          images: [
            {
              recordId: '0',
              ref_No: '0',
              image_Description: '0',
              image_Filename: '0',
              isDefault: true,
              folder: '0',
              url: '0',
              exp1: '0',
              exp2: '0',
              exp3: '0',
              createdBy: '0',
              createdOn: today,
              modifiedBy: '0',
              modifiedOn: today,
              isTemp: true,
              imagePath: '0',
            },
          ],
          isEdit: true,
        },
      };

      const postRes = await apiService.put('UPDATE_PROPERTY', body);
      if (postRes?.data?.statusCode === 200) {
        if (attachments) {
          handleUpload(postRes?.data?.result?.ref_No);
        }
        toast.success(postRes?.data?.message);
        setloader(false);
        navigate('/Customer/Property/Master/Property/Listing');
      } else {
        toast.warning(`${postRes?.data?.message}`);
        setloader(false);
      }
    } catch (error) {
      console.error('Error Save Data', error);
      setloader(false);
    } finally {
      setloader(false);
    }
  };

  const handleUpload = async (ref_No) => {
    const formData = new FormData();

    let token = localStorage.getItem('Token');
    let db = localStorage.getItem('DataBase');
    // const validFiles = attachments.filter(
    //     (item) => item.file instanceof File
    // );
    const validFiles = attachments.filter((item) => item.file instanceof File && item.isNew);
    validFiles.forEach(({ file }) => {
      formData.append('files', file);
    });

    formData.append('refNo', leaseData?.property_No);
    formData.append('fileCategory', 'Images');

    // ✅ DEBUG
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    const response = await axios.post('https://pmkleaseapi.apps.pro360erp.com/api/FileUpload/unit-files', formData, {
      headers: {
        accept: 'text/plain',
        apikey: 'V+kBloEwqqVho1PINmQI0VJQwSBX2l/e',
        Authorization: `Bearer ${token}`,
        db: db,
      },
    });

    console.log(response);
  };
  return (
    <div className="p-3">
      <div className="border-box2 p-2 d-flex justify-content-between" style={{ borderRadius: '8px' }}>
        <div className="">
          <h6>Update Property Master</h6>
        </div>
        <div className="d-flex gap-3">
          {loading === true ? (
            <div className="mainbtn flex-end gap-2">
              <ClipLoader color="#ffffff" className="mt-1" size={25} />
            </div>
          ) : (
            <div className="mainbtn flex-end gap-2" onClick={handleSave}>
              <FaSave color="#fff" className="center mt-1 mx-2" />
              <div className="center">Save</div>
            </div>
          )}
          <div className="mainbtnSecondary flex-end gap-2" onClick={handleBackClick}>
            <FaChevronLeft color="#fff" className="center mt-1 mx-2" />
            <div className="center">Back</div>
          </div>
        </div>
      </div>
      <div className="border-box2 my-3 p-3" style={{ borderRadius: '8px' }}>
        <div className="nav nav-pills overslid d-flex gap-4">
          <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`} onClick={() => handleTabClick(0)}>
            Details
          </div>
          <div className={`dashitems sidebar-text center ${activeTab === 3 ? 'sideActive' : ''}`} onClick={() => handleTabClick(3)}>
            Images
          </div>
        </div>
      </div>
      {gridVisibility[0] && (
        <PersonalDetails
          tableLoading={tableLoading}
          propertyType={propertyType}
          ownerShip={ownerShip}
          setTransectionData={setTransectionData}
          rowData={rowData}
          projectUse={projectUse}
          community={community}
          propertyCategory={propertyCategory}
          transectionData={transectionData}
          projectStatus={projectStatus}
          cityList={cityList}
          countriesList={countriesList}
          setCityList={setCityList}
        />
      )}
      {gridVisibility[3] && (
        <ImagesList
          attachments={attachments}
          deletedFiles={deletedFiles}
          setDeletedFiles={setDeletedFiles}
          setAttachments={setAttachments}
          createEmptyRow={createEmptyRow}
        />
      )}
    </div>
  );
};
export default PropertyMasterUpdate;
